<template>
	<van-tabs v-model="active" @click="onClick" title-active-color="#005DE5" color="#005DE5">
		<van-tab v-for="item in titleList" :key="item" :title="item | searchData(te)">
			<NoData v-if="!searchList.length && !Highlight.length" />
			<!-- <template v-if="searchList.length"> -->
			<div class="home-list" v-if="searchList.length">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<van-list
						v-model="loading"
						:finished="finished"
						:finished-text="searchList.length ? '已经到页面最底部啦~' : ''"
						@load="onLoad">
						<template v-for="(item, index) in searchList">
							<ListItem :key="index" :item="item"></ListItem>
						</template>
					</van-list>
				</van-pull-refresh>
			</div>
			<!-- </template> -->
			<div class="home-list" v-else>
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<van-list
						v-model="loading"
						:finished="finished"
						:finished-text="allList.length ? '已经到页面最底部啦~' : ''"
						@load="onLoad">
						<template v-for="(item, index) in Highlight">
							<ListItem :key="index" :item="item"></ListItem>
						</template>
					</van-list>
				</van-pull-refresh>
			</div>
		</van-tab>
	</van-tabs>
</template>

<script>
import ListItem from '@/components/listItemHeighSeach'
import NoData from '@/components/noData'
import '../../../assets/css/iconfont.css'
export default {
	name: 'SearchResult',
	props: {
		searchList: {
			type: Array,
			require: true
		},
		value: {
			type: String,
			require: true
		}
	},
	components: {
		ListItem,
		NoData
	},
	data() {
		return {
			active: 0,
			titleList: ['发件人', '主题', '收件人', '全部'],
			allList: [], // 全部的数据
			id: this.$store.state.List.seachId,
			refreshing: false,
			finished: false,
			loading: false,
			loadIndex: 0,
			seachForm: {
				page: 0,
				rows: 20,
				sidx: 'DateTimeReceived',
				sord: 'desc',
				queryData: {}
			},
			Highlight: [],
			scrollValue: 0
		}
	},
	computed: {
		queryData() {
			switch (this.loadIndex) {
				case 1: // 主题
					return {
						ParentFolderId: this.id,
						Subject: this.value
					}
				case 2: // 收件人
					return {
						ParentFolderId: this.id,
						DisplayTo: this.value
					}
				case 3: // 全部
					return {
						ParentFolderId: this.id,
						FuzzyCondition: this.value
					}
				default:
					// 发件人
					return {
						ParentFolderId: this.id,
						Sender: this.value
					}
			}
		}
	},
	mounted() {
		this.$emit('getFocus')
	},
	methods: {
		test() {
			this.finished = false
			this.refreshing = true
			this.allList = []
			this.onRefresh()
		},
		async onClick(name) {
			// 点击时搜索
			document.querySelector('.van-tabs__content').scrollTop = 0
			this.loadIndex = name
			this.finished = false
			this.refreshing = true
			this.allList = []
			this.onRefresh()
		},
		/* 重新加载 */
		async resetGetList() {
			this.refreshing = true
			this.onLoad()
		},
		/* 下拉加载更多 */
		onRefresh() {
			// 清空列表数据
			this.finished = false
			this.refreshing = true
			// 重新加载数据
			// 将 loading 设置为 true，表示处于加载状态
			this.loading = true
			this.onLoad()
		},
		/*列表加载数据*/
		onLoad() {
			/* 加载数据 */
			this.seachForm.page++
			let obj = { ...this.seachForm }
			obj.queryData = this.queryData
			if (this.refreshing) {
				obj.page = 1
				this.seachForm.page = 1
			}
			this.$api
				.getEmaListApp(obj)
				.then((res) => {
					if (res.Code === 0) {
						if (this.refreshing) {
							this.refreshing = false
							this.allList = []
						}
						const { Data } = res
						this.loading = false
						this.allList = this.allList.concat(Data.rows)
						this.Highlight = [...this.allList]
						this.newItem()
						// console.log(this.list)
						/* 所有数据加载完成 */
						if (!Data.rows.length) {
							this.finished = true
						}
					} else {
						this.loading = false
						this.finished = true
					}
				})
				.catch(() => {
					this.loading = false
					this.refreshing = false
					this.finished = true
				})
		},
		newItem() {
			this.Highlight = this.Highlight.map((item) => {
				console.log('高亮替换=---------', this.item)
				if (item.Sender) {
					item.Sender = { ...item.Sender, NameHtml: item.Sender.Name }
				}
				const replaceReg = new RegExp(this.value, 'g') // 匹配关键字正则
				const replaceString = '<span class="highlights-text">' + this.value + '</span>'
				if (this.value && this.value !== '') {
					item.Subject = item.Subject.replace(replaceReg, replaceString)
					item.Sender.NameHtml = item.Sender.NameHtml.replace(replaceReg, replaceString)
				}
				return item
			})
		},
		// 国际化
		te(arg) {
			const hasKey = this.$te(arg)
			if (hasKey) {
				const result = this.$t(arg)
				return result
			}
			return arg
		}
	}
}
</script>

<style scope lang="less">
.without {
	height: 300px;
	text-align: center;
	padding-top: 120px;
	.str {
		margin-top: 16px;
		color: #666666;
		font-size: 14px;
	}
}
.none-list {
	font-size: 50px;
}

.van-tab--active {
	color: #005de5;
}
.van-tab__text--ellipsis {
	font-weight: 600;
}
.van-tabs__wrap {
	position: fixed;
	top: 52px;
	width: 91%;
	z-index: 1000px;
}
.van-tabs__content {
	height: calc(100vh - 52px);
	margin-top: 100px;
	overflow: auto;
	padding-bottom: 20px;
}
.van-tab__pane {
	padding-bottom: 50px;
}
</style>
